import React, { useState } from "react";
import { EyeOffSvg, EyeSmallSvg } from "../../svgFile";

const FormInput = ({
  type = "text",
  name,
  placeholder,
  value,
  onChange,
  readOnly = false,
  onBlur,
  onKeyDown,
  className = "form-group mb-3 position-relative",
  inputClassName = ``,
  disabled = false,
  icon,
  error,
  isPassword = false,
  validationError = ""
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  return (
    <div className={className}>
      <input
        type={inputType}
        className={`form-control ${inputClassName} ${error || validationError ? 'is-invalid' : ''}`}
        placeholder={placeholder}
        name={name}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
      />
      {icon && <img src={icon} alt="" />}
      {isPassword && (
        <span
          className="eye-icon"
          onClick={() => setShowPassword(!showPassword)}
          style={{ cursor: "pointer" }}
        >
          {showPassword ? <EyeOffSvg /> : <EyeSmallSvg />}
        </span>
      )}
      {validationError && (
        <div className="invalid-feedback d-block" style={{ fontSize: "12px", marginTop: "5px" }}>
          {validationError}
        </div>
      )}
    </div>
  );
};

export default FormInput;